import React from "react";
import { IAccount } from "../../../../lib/features/accounts/account.constant";
import { Button, Dropdown, MenuProps } from "antd";
import ButtonUpdateAccount from "../button/ButtonUpdateAccount";
import ButtonChangePassword from "../button/ButtonChangePassword";

interface GroupButtonComponentProps {
  account: IAccount;
}

const GroupButtonComponent: React.FC<GroupButtonComponentProps> = (
  props: GroupButtonComponentProps
) => {
  const { account } = props;
  const items: MenuProps["items"] = [
    {
      disabled: true,
      key: "1",
      label: <ButtonUpdateAccount account={account} />,
    },
    {
      key: "2",
      label: <ButtonChangePassword accountId={account?._id} />,
    },
  ];
  return (
    <Dropdown menu={{ items }}>
      <Button icon={<i className="fa-solid fa-ellipsis-h text-lg"></i>} />
    </Dropdown>
  );
};

export default GroupButtonComponent;
